import React from "react";
import ApproveButton from "@components/FlowActionButtons/ApproveButton";
import { canUserApprove, type DeficiencyFlowData } from "./utils";

interface ApproveDeficiencyProps {
  deficiencyFlowData?: DeficiencyFlowData;
  onApprove?: () => void;
}

const LANG_BASE = "deficiencies";

const ApproveDeficiency: React.FC<ApproveDeficiencyProps> = ({
  deficiencyFlowData,
  onApprove = () => {},
}) => {
  if (!deficiencyFlowData?.task) {
    return null;
  }

  const isActionAvailable = canUserApprove(
    deficiencyFlowData.task.status,
    deficiencyFlowData.task.claimOwnerName,
    deficiencyFlowData.status,
  );

  return (
    <ApproveButton
      langBase={LANG_BASE}
      permission="canApproveFottDeficiency"
      isActionAvailable={isActionAvailable}
      onApprove={onApprove}
    />
  );
};

export default ApproveDeficiency;
